/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {Accordion, Panel} from 'baseui/accordion'
import {Block} from 'baseui/block'
import {Button} from 'baseui/button'
import {Card} from 'baseui/card'
import {ParagraphSmall} from 'baseui/typography'
import {format} from 'date-fns'
import React from 'react'

import {useSelector} from 'react-redux'
import PageScaffold from '../../components/app/page-scaffold'
import {routes} from '../../utils/config'
import {formatPrice} from '../../utils/helpers'
import CenteredBlock from '../../components/app/centered-block'
import RowBlock from '../../components/app/row-block'
import {BackButton} from '../../components/app'

const Orders = () => {
  const orders = useSelector(state => state.firestore?.data?.user?.orders)

  return (
    <>
      <RowBlock>
        <BackButton />
        <PageScaffold
          pageTitle={routes.enrollments.name}
          overrides={{
            Block: {
              style: ({$theme}) => ({
                marginLeft: '0%',
              }),
            },
          }}
        >
          <Block
            overrides={{
              Block: {
                style: ({$theme}) => ({
                  marginBottom: $theme.sizing.scale800,
                  maxWidth: '60rem',
                }),
              },
            }}
          >
            <Card title="Order Details">
              <Accordion>
                {orders.map(order => (
                  <Panel title={order.description || 'No Description'} key={order.paymentId}>
                    <ParagraphSmall>
                      Purchase date:
                      <strong> {format(order.createdAt.toDate(), 'MMMM dd, yyyy')}</strong>
                    </ParagraphSmall>
                    <ParagraphSmall>
                      Description:
                      <strong> {order.description || 'No Description'}</strong>
                    </ParagraphSmall>
                    <ParagraphSmall>
                      Amount:
                      <strong> {formatPrice(order.amount, order.currency)}</strong>
                    </ParagraphSmall>
                    <ParagraphSmall>
                      Payment ID:
                      <strong> {order.paymentId.substr(3)}</strong>
                    </ParagraphSmall>
                  </Panel>
                ))}
              </Accordion>
            </Card>
          </Block>
        </PageScaffold>
      </RowBlock>
    </>
  )
}

export default Orders
